// src/pages/ChapterFour.js
// Chapter 4 — Treb Lake: Machli Jal Ki Rani / Twinkle Magic
// Doron wakes up in this chapter and flies toward the lake. Playing
// "Machli Jal Ki Rani" (same notes as "Twinkle Twinkle") puts Doron
// back to sleep and rallies the fish to gather for safety.

import React from "react";
import ChapterTemplate from "../components/ChapterTemplate";

// 🎵 Machli Jal Ki Rani (same as Twinkle Twinkle) — key of C, kid-friendly
const twinkleLikeMelody = [
  // Phrase 1
  "C", "C", "G", "G", "A", "A", "G",
  "F", "F", "E", "E", "D", "D", "C",
  // Phrase 2
  "G", "G", "F", "F", "E", "E", "D",
  // Phrase 3 (repeat of phrase 2)
  "G", "G", "F", "F", "E", "E", "D",
  // Phrase 4
  "C", "C", "G", "G", "A", "A", "G",
  "F", "F", "E", "E", "D", "D", "C",
];

// Optional pretty layout for on-screen note bubbles (Template will flatten)
const twinkleLines = [
  ["C", "C", "G", "G", "A", "A", "G"],
  ["F", "F", "E", "E", "D", "D", "C"],
  ["G", "G", "F", "F", "E", "E", "D"],
  ["G", "G", "F", "F", "E", "E", "D"],
  ["C", "C", "G", "G", "A", "A", "G"],
  ["F", "F", "E", "E", "D", "D", "C"],
];

// 🖼️ Story slides (placeholder images + text). Swap images later without refactor.
const ChapterFourStory = [
  {
    image: "/images/ChapterFour/Ch4 Slide 1.png",
    text: "Pan and Wis arrive at Treb Lake. The fish sparkle under the sun—it's calm... for now.",
  },
  {
    image: "/images/ChapterFour/Ch4 Slide 2.png",
    text: "Suddenly, Doron stirs and takes to the sky, flying straight toward the lake!",
  },
  {
    image: "/images/ChapterFour/Ch4 Slide 3.png",
   // text: "The fish scatter in fear. Ripples race across the water. We need a plan—fast!",
  },
  {
    image: "/images/ChapterFour/Ch4 Slide 4.png",
    text: "\"Play ‘Machli Jal Ki Rani’!\" says Wis. \"It has the same magic spell as ‘Twinkle Twinkle’.\"",
  },
];

export default function ChapterFour() {
  return (
    <ChapterTemplate
      chapterNumber={4}
      chapterTitle="Treb Lake — Machli Jal Ki Rani (Twinkle Magic)"
      sceneImageSrc="/images/ChapterFour/Ch4 Slide 3.png"
      storySlides={ChapterFourStory}
      targetMelody={twinkleLikeMelody}
      melodyLines={twinkleLines}
      songTitle="Machli Jal Ki Rani (same as Twinkle Twinkle)"
      companionsText={{
        wis: "Play it steady—this melody will calm the lake and make Doron sleep again!",
        pan: "We can do it! Follow the notes and keep the beat.",
      }}
      unlockNextChapterPath="/chapter-5"
      // Make Doron start awake in this chapter; he sleeps after completion.
      // (Requires the tiny logic in ChapterTemplate: doronStartsAwake = chapterNumber===1||4)
      doronAwakeInitially={true}
    />
  );
}
